/**
 * Check if the app is at a portal endpoint
 */
export const isBrandPortal = () => {
	// eslint-disable-next-line no-unreachable
	return window.location.pathname.match(/^\/portals\//) != null;
};
